import { render } from "./UpdateInfoView.vue?vue&type=template&id=3314b978"
import script from "./UpdateInfoView.vue?vue&type=script&lang=js"
export * from "./UpdateInfoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__